import React from 'react'
import { FRAUD_IMG } from '../../../../../utils/app-image-contant';

const FraudsAlertModal = ({
  handleCloseModal, showFraudModal
}) => {
  return (
    <div>
      <div class={`modal fade ${showFraudModal ? "show" : ""}`} style={{ display: showFraudModal ? 'block' : 'none', background: showFraudModal ? 'rgba(0,0,0,0.5)' : '', zIndex: showFraudModal ? '99999' : '' }}>
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <div className='row w-100'>
                <div className='col-11 col-sm-10 col-md-11 col-lg-11 pe-0'>
                  <h5 class="modal-title text-center text-danger fraud_modal_title ms-5" >धोखेबाजों से सावधान !!</h5>
                </div>
                <div className='col-1 col-sm-1 col-md-1 col-lg-1 d-flex justify-content-end align-items-center ps-0'>
                  <button type="button" class="btn-close" onClick={handleCloseModal}></button>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <img src={FRAUD_IMG} alt='' className='w-100 fraud_banner img-fluid' />
            </div>
            <div class="modal-footer">
              <button type="button" class="submitbtn common-btn-style" onClick={handleCloseModal}>Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FraudsAlertModal
